import { CommonModule } from '@angular/common';
import { NgModule, Component, HostBinding, ChangeDetectionStrategy, ViewEncapsulation, Input } from '@angular/core';
import { BaseDirective } from '../../../base.directive';

@Component({
    selector: 'span[euiBadge], eui-badge',
    template: '<ng-content></ng-content>',
    styleUrls: ['./styles/_index.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class EuiBadgeComponent extends BaseDirective {
    @HostBinding('class')
    public get cssClasses(): any {
        return this.getCssClasses();
    }
    @HostBinding('attr.aria-label')
    @Input('aria-label')
    public get ariaLabel(): string {
        return this._ariaLabel;
    }
    public set ariaLabel(value: string|null) {
        this._ariaLabel = value;
    }

    protected _ariaLabel = 'eUI Badge';

    constructor() {
        super();
    }

    getCssClasses() {
        return [
            super.getCssClasses('eui-badge'),
        ].join(' ').trim();
    }
}

@NgModule({
    imports: [CommonModule],
    exports: [EuiBadgeComponent],
    declarations: [EuiBadgeComponent],
})
export class EuiBadgeModule {
}
